if (!customElements.get('bbcr-purchase-nav')) {
  customElements.define('bbcr-purchase-nav', class extends HTMLElement {
    connectedCallback() {
      this.productInfo = this.closest('product-info');
      if (!this.productInfo) return;
      this.summary = this.querySelector('.bbcr-purchase-nav__summary');
      this.button = this.querySelector('button');
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.update = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.refresh();
        });
      };
      this.goToOptions = () => {
        const picker = this.productInfo.querySelector('variant-selects');
        if (!picker) return;
        picker.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start'});
        const control = picker.querySelector('input:checked, select');
        control?.focus({preventScroll: true});
      };
      this.button.addEventListener('click', this.goToOptions);
      window.addEventListener('scroll', this.update, {passive: true});
      window.addEventListener('resize', this.update);
      window.visualViewport?.addEventListener('resize', this.update);
      this.mobile.addEventListener('change', this.update);
      this.productInfo.addEventListener('change', this.update);
      this.observer = new MutationObserver(this.update);
      this.observer.observe(this.productInfo, {childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'class', 'open']});
      this.overlayObserver = new MutationObserver(records => {
        if (records.some(record => record.target.matches('cart-drawer, .cart-drawer, .menu-drawer-container, .product-media-modal, dialog'))) this.update();
      });
      this.overlayObserver.observe(document.body, {subtree: true, attributes: true, attributeFilter: ['class', 'open']});
      this.refresh();
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.update);
      window.removeEventListener('resize', this.update);
      window.visualViewport?.removeEventListener('resize', this.update);
      this.mobile?.removeEventListener('change', this.update);
      this.productInfo?.removeEventListener('change', this.update);
      this.button?.removeEventListener('click', this.goToOptions);
      this.observer?.disconnect();
      this.overlayObserver?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      document.body.classList.remove('bbcr-purchase-nav-active');
    }
    refresh() {
      const picker = this.productInfo.querySelector('variant-selects');
      const submit = this.productInfo.querySelector('product-form button[name="add"]');
      if (!picker || !submit) {
        this.hidden = true;
        document.body.classList.remove('bbcr-purchase-nav-active');
        return;
      }
      const values = [...picker.querySelectorAll('input[type="radio"]:checked, select')].map(control =>
        control.tagName === 'SELECT' ? control.options[control.selectedIndex]?.textContent.trim() : control.value
      ).filter(Boolean);
      const selection = values.join(' · ');
      if (this.summary.textContent !== selection) this.summary.textContent = selection;
      const viewportHeight = window.visualViewport?.height || window.innerHeight;
      const keyboardOpen = window.innerHeight - viewportHeight > 150;
      const visible = element => {
        const rect = element.getBoundingClientRect();
        return rect.bottom > 0 && rect.top < viewportHeight - 85;
      };
      const modalOpen = [...document.querySelectorAll('dialog[open], .cart-drawer.active, cart-drawer.active, .menu-drawer-container[open], .product-media-modal[open]')].some(visible);
      const shouldShow = this.mobile.matches && !keyboardOpen && !modalOpen && !visible(picker) && !visible(submit);
      const label = picker.getBoundingClientRect().bottom <= 0 ? this.dataset.reviewLabel : this.dataset.chooseLabel;
      if (this.button.textContent !== label) this.button.textContent = label;
      if (this.hidden === shouldShow) this.hidden = !shouldShow;
      document.body.classList.toggle('bbcr-purchase-nav-active', shouldShow);
    }
  });
}
